/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { NgModule } from '@angular/core';
import { DateAdapter, MAT_DATE_LOCALE_PROVIDER } from './date-adapter';
import { NativeDateAdapter } from './native-date-adapter';
import { MAT_DATE_FORMATS } from './date-formats';
import { MAT_NATIVE_DATE_FORMATS } from './native-date-formats';
export { MAT_DATE_LOCALE, MAT_DATE_LOCALE_PROVIDER, DateAdapter } from './date-adapter';
export { MAT_DATE_FORMATS } from './date-formats';
export { NativeDateAdapter } from './native-date-adapter';
export { MAT_NATIVE_DATE_FORMATS } from './native-date-formats';
var NativeDateModule = (function () {
    function NativeDateModule() {
    }
    NativeDateModule.decorators = [
        { type: NgModule, args: [{
                    providers: [
                        { provide: DateAdapter, useClass: NativeDateAdapter },
                        MAT_DATE_LOCALE_PROVIDER
                    ],
                },] },
    ];
    /**
     * @nocollapse
     */
    NativeDateModule.ctorParameters = function () { return []; };
    return NativeDateModule;
}());
export { NativeDateModule };
function NativeDateModule_tsickle_Closure_declarations() {
    /** @type {?} */
    NativeDateModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    NativeDateModule.ctorParameters;
}
var MatNativeDateModule = (function () {
    function MatNativeDateModule() {
    }
    MatNativeDateModule.decorators = [
        { type: NgModule, args: [{
                    imports: [NativeDateModule],
                    providers: [{ provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS }],
                },] },
    ];
    /**
     * @nocollapse
     */
    MatNativeDateModule.ctorParameters = function () { return []; };
    return MatNativeDateModule;
}());
export { MatNativeDateModule };
function MatNativeDateModule_tsickle_Closure_declarations() {
    /** @type {?} */
    MatNativeDateModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatNativeDateModule.ctorParameters;
}
//# sourceMappingURL=index.js.map